import {Box, styled, Typography} from '@mui/material';
import PlayArrowIcon from '@mui/icons-material/PlayArrow';
import React, {useCallback} from 'react';
import {COLOR_DANGER, COLOR_SUCCESS, textColorGray} from '../../styles';

const StatWrapper = styled(Box)((props: {size?: 'default' | 'small'}) => ({
  display: 'flex',
  flexDirection: 'column',
  flexBasis: 0,
  flexGrow: 1,
  alignItems: 'center',
  marginTop: props.size === 'small' ? '1px' : '5px',
  marginBottom: props.size === 'small' ? '1px' : '5px',
}));

const StatValueWrapper = styled(Box)(() => ({
  display: 'flex',
  flexDirection: 'row',
  alignItems: 'flex-end',
}));

const StatValue = styled(Typography)(() => ({
  fontFamily: 'Orbitron',
}));

const StatValueUnit = styled(Typography)(() => ({
  marginLeft: '2px',
  color: textColorGray,
}));

const StatCaption = styled(Typography)(
  (props: {whiteLabel?: boolean; size?: 'default' | 'small'}) => ({
    color: props.whiteLabel ? '#ffffff' : textColorGray,
    textAlign: 'center',
    marginTop: props.size === 'small' ? '1px' : '5px',
  }),
);

interface Props {
  label?: string;
  unit?: string;
  value: string | number | null;
  whiteLabel?: boolean;
  size?: 'default' | 'small';
  shrinkText?: boolean;
  comparison?: 'up' | 'down';
  statDifference?: string | null;
}

const SessionTileStat: React.FC<Props> = ({
  label,
  unit,
  value,
  whiteLabel,
  size,
  shrinkText,
  comparison,
  statDifference,
}) => {
  const renderBaselineIcon = useCallback((comparision?: string) => {
    if (comparision === 'up') {
      return (
        <PlayArrowIcon
          sx={{
            fontSize: 24,
            color: COLOR_SUCCESS,
            transform: ['rotate(-90deg)'],
          }}
        />
      );
    } else if (comparision === 'down') {
      return (
        <PlayArrowIcon
          sx={{
            fontSize: 24,
            color: COLOR_DANGER,
            transform: ['rotate(90deg)'],
          }}
        />
      );
    } else {
      return null;
    }
  }, []);

  return (
    <StatWrapper size={size}>
      <Box
        sx={{
          display: 'flex',
          flexDirection: 'row',
          alignItems: 'center',
        }}>
        {comparison && renderBaselineIcon(comparison)}
        <StatValueWrapper>
          <StatValue variant={shrinkText ? 'body2' : 'h4'}>{value}</StatValue>
          {unit ? <StatValueUnit variant="body2">{unit}</StatValueUnit> : null}
          {statDifference && (
            <StatValue sx={{ml: 1}} variant="body2">
              {statDifference}
            </StatValue>
          )}
        </StatValueWrapper>
      </Box>
      {label ? (
        <StatCaption whiteLabel={whiteLabel} size={size} variant="body2">
          {label}
        </StatCaption>
      ) : null}
    </StatWrapper>
  );
};

export default SessionTileStat;
